import {
    BANKBRANCHLIST_SUCCESS,
    BANKBRANCHLIST_FAILED,
    RESET_BANKBRANCHLIST,
    LOADING_BANKBRANCHLIST,
    BANKBRANCHLIST_NETWORKERROR,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BANKBRANCHLIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case BANKBRANCHLIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case BANKBRANCHLIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case BANKBRANCHLIST_NETWORKERROR:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_BANKBRANCHLIST:
            return (state = initialState);
        default:
            return state;
    }
};
